import { forwardRef, useState, useRef } from "react";
import { CIFType, Metric, expandedPresenceConfigState } from "../../states";
import { Body, BodyColor, BodyType } from "../../ui-elements";
import { useRecoilValue } from "recoil";

interface PopupProps {
    type: CIFType | 'catchments' | 'subregionBoundaries';
    isChecked: boolean;
    isDisabled?: boolean;
    selMetric: Metric;
    metrics: Metric[];
    isOpen: boolean;
    infoText: string | null;
    handleOpen: () => void;
    setSelMetric: any;
}

export const OverlayMetricPopup = forwardRef<HTMLDivElement, PopupProps>(({ type, isChecked, isDisabled, selMetric, metrics, isOpen, infoText, handleOpen, setSelMetric }, ref) => {
    const expandedPresenceConfig = useRecoilValue(expandedPresenceConfigState);
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    // const [selTempMetric, setSelTempMetric] = useState<Metric | null>(
    //     metrics?.find(item => item.key === selMetric?.key) || null
    // );

    const handleChangeMetrics = (item: Metric) => {
        setSelMetric((prev: any) => {
            if (type === 'PoI' || type === 'CTV' || type === 'EH') {
                const update = { ...prev, [type]: { ...item, isRank: true } };
                localStorage.setItem("selMetrics", JSON.stringify(update));
                return update;
            } else {
                return item;
            }
        });
        handleOpen();
    }

    const handlepopupOpen = (type: string) => {
        handleOpen();
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const offset = (type === "PoI" && expandedPresenceConfig != null ? 180 : 10);
            setPosition({
                top: rect.bottom - offset, // or rect.top for above
                left: rect.left,
            });
        }
    };

    // const handleCancelMetricFilter = (): void => {
    //     setSelTempMetric(metrics[0]);
    //     handleOpen();
    // }

    // const handleApplyMetricFilter = (): void => {
    //     setSelMetric(prev => {
    //         const update = { ...prev, [type]: selTempMetric };
    //         localStorage.setItem("selMetrics", JSON.stringify(update));
    //         return update;
    //     });
    //     handleOpen();
    // }
    // useEffect(() => {
    //     if (selMetric && metrics && isOpen) {
    //         const found = metrics.find(item => item.key === selMetric?.key);
    //         setSelTempMetric(found || null);
    //     }
    // }, [selMetric, metrics, type, isOpen]);

    return (
        <>
            {(infoText || metrics?.length > 0) &&
                <div className={`w-100 d-flex justify-content-between align-items-center col-1 position-relative p-0 padding-top-bottom-1 ${isDisabled && type !== 'subregionBoundaries' ? 'cursor-default opacity-50' : 'cursor-pointer'}`} ref={buttonRef}>
                    {infoText &&
                        <Body
                            type={BodyType.p3}
                            color={BodyColor.secondary}
                            classname=""
                        >
                            {infoText}
                        </Body>}
                    {metrics?.length > 1 &&
                        <span
                            className={`material-symbols-outlined fs-18 fw-bold icon-gray-0 p-0 ${isDisabled && type !== 'subregionBoundaries' ? 'cursor-default opacity-50 pe-none' : 'cursor-pointer'}`}
                            onClick={() => handlepopupOpen(type)}
                        >
                            keyboard_arrow_right
                        </span>}
                </div>}
            {isOpen &&
                <div
                    ref={ref}
                    className={`overlay-metric-popup d-flex flex-column justify-content-center align-items-start bg-white rounded padding-top-bottom-3 ${type === 'subregionBoundaries' ? 'left-78' : ''}`}
                    style={{
                        position: 'fixed',
                        top: `${position.top}px`,
                        zIndex: 9999,
                    }}                   >
                    <div className="d-flex flex-column gap-2 padding-2 w-100">
                        {metrics?.map(item => (
                            <label key={item.key} className="d-flex align-items-center justify-content-between gap-4">
                                <div className="d-flex align-items-center justify-content-start gap-1 m-0 p-0">
                                    <input
                                        type="radio"
                                        value={item.key}
                                        checked={selMetric?.key === item.key}
                                        onChange={() => handleChangeMetrics(item)}
                                    />
                                    <Body
                                        type={BodyType.p3}
                                        color={BodyColor.secondary}
                                        classname="p-0"
                                    >
                                        {item.title} {item.hasOwnProperty('count') ? ` (${item.count})` : ''}
                                    </Body>
                                </div>
                                {item.icon && <img src={item.icon} alt={item.title} />}
                            </label>
                        ))}
                    </div>
                    {/* <div className="d-flex justify-content-around align-items-center padding-top-bottom-3 border-top padding-left-right-5 w-100">
                            <Button
                                theme={ButtonTheme.primary}
                                variant={ButtonVariant.transparent}
                                type='button'
                                classname='padding-left-right-3 text-underline'
                                onClick={handleCancelMetricFilter}
                            >
                                Cancel
                            </Button>
                            <Button
                                theme={ButtonTheme.primary}
                                variant={ButtonVariant.bordered}
                                type='button'
                                classname='padding-left-right-5'
                                onClick={handleApplyMetricFilter}
                            >
                                Apply
                            </Button>
                        </div> */}
                </div>}
        </>
    );
});